import './styles/main.scss'

import Lottie from 'lottie-web'

import Experience from './Experience/Experience.js'

const loader = document.getElementsByClassName('loader')

const experience = new Experience(document.querySelector('canvas.webgl'))
document.querySelector('.home__start-button').addEventListener('click', () => {
  document.querySelector('section').style.opacity = 0
  document.querySelector('.home__cercle').style.opacity = 0
  setTimeout(() => {
    document.querySelector('.home').style.display = 'none'
    document.querySelector('.home__cercle').style.display = 'none'
  }, 1000)
  setTimeout(() => {
    document.querySelector('.header-logo').style.display = 'block'
  }, 500)
})

// document.querySelector('.overlay__close').addEventListener('click', () => {
//   console.log("close")
//   document.querySelector('.overlay').style.animationName = 'slideout'
//   setTimeout(() => {
//     document.querySelector('.overlay').style.display = 'none'
//   }, 2000)
// })
const imghover0 = document.querySelector('.img-hover0')
const imghover1 = document.querySelector('.img-hover1')
const imghover2 = document.querySelector('.img-hover2')

window.addEventListener('mousemove', (event) => {
  const x = event.clientX / 2 // Get the horizontal coordinate
  const y = event.clientY / 2

  imghover0.style.top = `${y}px`
  imghover0.style.left = `${x}px`

  imghover1.style.top = `${y}px`
  imghover1.style.left = `${x}px`

  imghover2.style.top = `${y}px`
  imghover2.style.left = `${x}px`
})
